import type from "./type";

export default type("text/html", function(xhr) {
  return document.createRange().createContextualFragment(xhr.responseText);
});



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-request/src/html.js
// module id = ../../../../d3-request/src/html.js
// module chunks = 4